import { useAppSelector } from '../../configuration/setup/hooks';
import type { RootState } from '../../configuration/setup/store';

export const isServiceInfoDialogShown = (state: RootState) => state.serviceInfo.showServiceInfoDialog;
export const getServiceInfoDialogChapter = (state: RootState) => state.serviceInfo.serviceInfoChapter;

export const useIsServiceInfoDialogShown = () => useAppSelector(isServiceInfoDialogShown);
export const useServiceInfoDialogChapter = () => useAppSelector(getServiceInfoDialogChapter);
